<aw-banner></aw-banner>

@if (corporateDesignStore.isLoading() || configurationStore.isLoading()) {
  <div class="pt-32">
    <aw-loading-animation
      [entityType]="EEntityType.corporateDesign"
      [relationType]="ERelationType.loading"></aw-loading-animation>
  </div>
}
@if (
  configuration() &&
  configurationStore.getBooleanConfiguration(
    CONFIGURATION_SETTING_KEYS.IsCustomTilePageActive
  )
) {
  <custom-tiles></custom-tiles>
}
